// renders the preview page without the field icons

import React from 'react';
import { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import SelectMultipleTemplate from './select_multiple/select_multiple';
import { ControlPropType, formDesignProps } from '../ctrl_proptype';
import ImageChoiceTemplate from './image-choice/image_choice';
import RadioTemplate from './radio-buttons/radio_buttons';
import MediaHeader from './section-header/section-header';
import LabeledInput from './labeled-input/labeled_input';
import MatrixRating from './matrix_rating/matrix_rating';
import InventoryField from './inventory/inventory_field';
import HeartRating from './heart_rating/heart_rating';
import SelectBasic from './select_basic/single_basic';
import PhoneNumber from './phoneNumber/phone-number';
import Flutterwave from './flutterwave/flutterwave';
import Description from './description/description';
import StarRating from './star_rating/star_rating';
import FileUpload from './file_upload/file_upload';
import EmbedField from './embed-video/embed-field';
import TableField from './table_field/table_field';
import TextInput from './text-input/text_input';
import NumberInput from './number-field/number';
import CheckBox from './checkboxes/checkboxes';
import Signature from './signature/signature';
import ScaleRating from './scale-field/scale';
import LongText from './long-text/long_text';
import DateTime from './date-time/date-time';
import AddImage from './add_Image/add_image';
import Paystack from './paystack/paystack';
import Country from './country/country';
import Address from './address/address';
import Ranking from './ranking/ranking';
import Email from './email-field/email';
import Website from './website/website';
import AddRow from './add-row/add-row';
import Stripe from './stripe/stripe';
import Lookup from './lookup/lookup';
import Paypal from './paypal/paypal';
import Smiley from './smiley/smiley';

const Wrapper = styled.div`
  padding: 0.5rem 0;
`;

const PreviewFormField = ({ ctrl, rowCtrls, formDesign, isRenderedOnModal }) => {
  const Fields = {
    email: Email,
    stripe: Stripe,
    lookup: Lookup,
    paypal: Paypal,
    add_row: AddRow,
    country: Country,
    address: Address,
    ranking: Ranking,
    website: Website,
    phone: PhoneNumber,
    datetime: DateTime,
    paystack: Paystack,
    text_area: LongText,
    signature: Signature,
    checkboxes: CheckBox,
    text_input: TextInput,
    short_text: TextInput,
    smiley_rating: Smiley,
    media_image: AddImage,
    table_field: TableField,
    file_upload: FileUpload,
    star_rating: StarRating,
    embed_field: EmbedField,
    description: Description,
    flutterwave: Flutterwave,
    number_input: NumberInput,
    scale_rating: ScaleRating,
    heart_rating: HeartRating,
    select_basic: SelectBasic,
    media_header: MediaHeader,
    matrix_rating: MatrixRating,
    inline_checkboxes: CheckBox,
    labeled_input: LabeledInput,
    appended_text: LabeledInput,
    radio_buttons: RadioTemplate,
    inline_radios: RadioTemplate,
    prepended_text: LabeledInput,
    inventory_field: InventoryField,
    image_choice: ImageChoiceTemplate,
    select_multiple: SelectMultipleTemplate,
  };

  const Field = Fields[ctrl.type];
  return (
    <Wrapper>
      <Field
        ctrl={ctrl}
        inTable={false}
        rowCtrls={rowCtrls}
        formDesign={formDesign}
        isRenderedOnModal={isRenderedOnModal}
      />
    </Wrapper>
  );
};

PreviewFormField.defaultProps = {
  isRenderedOnModal: false,
  formDesign: null,
};

PreviewFormField.propTypes = {
  isRenderedOnModal: PropTypes.bool,
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  rowCtrls: PropTypes.objectOf(PropTypes.any).isRequired,
  formDesign: PropTypes.shape(formDesignProps).isRequired,
};
export default PreviewFormField;
